import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useNicheMissingPersons(
  groupType,
  groupCodes = [],
  { highRisk = false } = {},
) {
  const queryKey = ['nicheMissingPersons', groupType, groupCodes, highRisk];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      const searchParams = new URLSearchParams(
        [
          groupType && ['groupType', groupType],
          ...groupCodes.map((code) => ['groupCodes', code]),
          highRisk && ['highRisk', highRisk],
        ].filter(Boolean),
      );

      return platformApi
        .get('niche/missing-persons', { searchParams, signal })
        .json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
    enabled: !!groupType && groupCodes.length > 0,
  });

  return { query, cancel: () => queryClient.cancelQueries({ queryKey }) };
}
